import CircularProgress from "@mui/material/CircularProgress";
import { ReactNode } from "react";
import { useGeotabClient } from "./GeotabClientContext";
import NotLicensedPage from "./login/NotLicensedPage";
import { useLicenseCheck } from "@/hooks/pageLicenseCheck/useLicenseCheck";

interface Props {
  children: ReactNode;
  name: string;
}

/**
 * Component that checks, whether the Product is Licensed to the account
 * sha256 hash of database name === {name}'s group comment or @fairfleet.de account
 * @remarks This component is only used in development mode.
 */
export function LicensedBoundary({ children, name }: Props) {
  const { me } = useGeotabClient();
  const { licensedState, isDmGroupLoading } = useLicenseCheck(name, me);
  if (import.meta.env.DEV) return children;
  if (name === "Homepage") return children;
  if (isDmGroupLoading || licensedState === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
  if (licensedState === -1) {
    return <NotLicensedPage />;
  }

  return children;
}
